import PropTypes from 'prop-types';
import ButtonCTA from '@/components/component-library/Button/CTA';
import RetryIcon from '@/components/component-library/Icon/types/Retry';

const RetryButton = ({
  onRetry,
  className
}) => {
  return (
    <ButtonCTA
      className={className}
      onClick={onRetry}
    >
      Retry
      <RetryIcon />
    </ButtonCTA>
  );
};

RetryButton.propTypes = {
  onRetry: PropTypes.func.isRequired,
  className: PropTypes.string
};

RetryButton.defaultProps = { className: '' };

export default RetryButton;
